import styled from 'styled-components';
import { hideScrollbar } from '@finect/tabular-utils/hideScrollbar';
export var Items = styled.div.withConfig({
  displayName: "Items",
  componentId: "sc-83mlws-0"
})(["display:flex;overflow-x:scroll;overflow-y:hidden;scrollbar-width:none;-ms-overflow-style:none;", ""], hideScrollbar);
export var Item = styled.div.withConfig({
  displayName: "Items__Item",
  componentId: "sc-83mlws-1"
})(["display:flex;flex-grow:0;flex-shrink:0;width:", ";", ";", ";> *{width:100%;}"], function (_ref) {
  var itemWidth = _ref.itemWidth;
  return "".concat(itemWidth, "px");
}, function (_ref2) {
  var itemMarginRight = _ref2.itemMarginRight;
  return "margin-right: ".concat(itemMarginRight, "px");
}, function (_ref3) {
  var isDragging = _ref3.isDragging;
  return isDragging ? "user-select: none; cursor: move" : '';
});